const replacements = {
  watemelon: "watermelon",
  soursoup: "soursop",
};

const normalizeName = (value = "") => {
  let normalized = value.trim().toLowerCase();
  normalized = normalized.replace(/[._-]+/g, " ");
  normalized = normalized.replace(/\s+/g, " ");

  Object.keys(replacements).forEach((key) => {
    const regex = new RegExp(`\\b${key}\\b`, "g");
    normalized = normalized.replace(regex, replacements[key]);
  });

  return normalized;
};

export default normalizeName;
